var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeciality6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.d{fill:#bccbe3;opacity:0.332;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-2861 -3943)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2861 3943)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3618.865 -5070.69)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.681,4.349,0,0",
    transform: "translate(779.678 1133.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.482,2.452,0,0",
    transform: "translate(777.555 1136.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.243,3.927,0,0",
    transform: "translate(783.555 1133.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.548,29.249a8.335,8.335,0,0,0-8.881,2.872A8.336,8.336,0,0,0,4.261,30.472,8.555,8.555,0,0,0,1.1,39.578,9.821,9.821,0,0,0,2.876,43.39a3.09,3.09,0,0,1,.707,2.1A17.459,17.459,0,0,0,7.529,57.148a1.538,1.538,0,0,0,2.678-.587,73.047,73.047,0,0,1,2.263-7.094,3.415,3.415,0,0,1,6.394,0,71.884,71.884,0,0,1,2.265,7.094,1.522,1.522,0,0,0,1.147,1.114,1.539,1.539,0,0,0,1.521-.516,17.476,17.476,0,0,0,3.957-11.676,3.051,3.051,0,0,1,.7-2.086,9.9,9.9,0,0,0,1.786-3.849,8.9,8.9,0,0,0-.4-5.591",
    transform: "translate(759.12 1114.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M42.742,37.772A12.01,12.01,0,0,1,44.28,40.49",
    transform: "translate(732.045 1108.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M87.377,7.975l-6.707,5.078L76.086,8.428l5.03-6.77a2.831,2.831,0,0,1,4.025,0l2.234,2.256A2.892,2.892,0,0,1,87.377,7.975Zm0,0",
    transform: "translate(710.509 1132.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.313,0,0,2.336",
    transform: "translate(784.255 1145.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M116.784,27.522a53.48,53.48,0,0,1-8.176-6.287c-.413-.387-.642-.611-.642-.611",
    transform: "translate(689.917 1119.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0,8.644,8.728",
    transform: "translate(792.909 1144.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M77.931,27.362l-1.764,1.782a.817.817,0,0,1-1.164,0L73.819,27.95a.835.835,0,0,1,0-1.175l1.764-1.782",
    transform: "translate(712.129 1116.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M63.75,44.378a3.156,3.156,0,0,1-3.141-3.17",
    transform: "translate(720.506 1106.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M10.329,22.281a6.373,6.373,0,0,0-3.72,1.188,6.626,6.626,0,0,0-2.4,7.027,10.75,10.75,0,0,0,.5,1.51,13.024,13.024,0,0,1,1.055-2.752,6.98,6.98,0,0,1,2.556-2.765,9.41,9.41,0,0,1,4.545-.981c1.064-.024,2.128.009,3.189.087l-.672-.853a6.4,6.4,0,0,0-5.052-2.461",
    transform: "translate(757.89 1123.049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality6);
export default __webpack_public_path__ + "static/media/speciality6.836e0ae0f18c89fb85f14a1bee60dc8d.svg";
export { ForwardRef as ReactComponent };